const botmsg = state => state.botmsg;

export default {
  botmsg
};



// WEBPACK FOOTER //
// ./src/store/modules/teachbot/getters.js